import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { StockMenuRequestBody, StockMenuResponse } from "./types";

export class StockMenuAPI extends BaseAPI<
  StockMenuRequestBody,
  StockMenuResponse
> {
  protected route = ApiRoutes.menu.stock;
  protected method = RequestMethod.POST;
}
